<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">排班信息</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-table :data="dataList" height="400" border>
          <el-table-column label="类型" prop="type">
            <template slot-scope="scope">
              <p v-if="scope.row.type==2">两班制</p>
              <p v-if="scope.row.type==3">三班制</p>
            </template>
          </el-table-column>
          <el-table-column label="详情" prop="type">
            <template slot-scope="scope">
              <div v-if="scope.row.type==2">

                <div>白班</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.nursingSchedulingDaytime.nursingSchedulingDaytimeItemList" :key="index">
                  <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                  <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                </div>
                <div>夜班</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.nursingSchedulingNighttime.nursingSchedulingNighttimeItemList" :key="index">
                  <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                  <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                </div>

              </div>
              <div v-if="scope.row.type==3">

                <div>早班</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.nursingSchedulingMorning.nursingSchedulingMorningItemList" :key="index">
                  <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                  <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                </div>
                <div>中班</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.nursingSchedulingNoon.nursingSchedulingNoonItemList" :key="index">
                  <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                  <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                </div>
                <div>晚班</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.nursingSchedulingNight.nursingSchedulingNightItemList" :key="index">
                  <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                  <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                </div>

              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间" :formatter="timefilter" prop="time"></el-table-column>
          <el-table-column label="星期" prop="day"></el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>

<script>

import {timefilters} from "@/common/times";

export default {
  name: "Add",
  props:['dataList'],
  data() {
    return {

      loading: false,

      showModalAdd:false,

      th:0,

    }
  },

  methods: {
    init(){

    },
    closeSelf() {
      this.$emit("closeInfo");
    },
    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,10)
    },



  }
}
</script>

<style  lang="scss" scoped>

</style>
